// removed by extract-text-webpack-plugin
module.exports = {"buttonSection":"freeItemSection-module_buttonSection_1qgRk"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/freeItemSection/freeItemSection.module.css
// module id = 472
// module chunks = 1 3